import MuiTooltip from '@mui/material/Tooltip';

import type { TooltipProps } from '@mui/material/Tooltip';
import type { FC } from 'react';

const Tooltip: FC<TooltipProps> = (props) => <MuiTooltip {...props} />;

Tooltip.displayName = 'Tooltip';

export default Tooltip;
export type { TooltipProps };
